module.exports = __webpack_public_path__ + "img/english_logo.d6d935e0.png";